import axios from "axios";

const BASE_URL = process.env.NEXT_PUBLIC_API_URL; // e.g., http://laravel.test/api
const SANCTUM_URL = BASE_URL?.replace("/api", ""); // e.g., http://laravel.test

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/json",
  },
});

// Request interceptor
api.interceptors.request.use(async (config) => {
  try {
    // check if XSRF-TOKEN is set
    if (typeof window !== "undefined") {
      const xsrfToken = document.cookie
        .split("; ")
        .find((row) => row.startsWith("XSRF-TOKEN="));

      if (xsrfToken) {
        config.headers["X-XSRF-TOKEN"] = xsrfToken.split("=")[1];

        return config;
      }
    }

    // Only get CSRF token if it hasn't been set yet
    await axios.get(`${SANCTUM_URL}/sanctum/csrf-cookie`, {
      withCredentials: true,
      withXSRFToken: true,
    });

    return config;
  } catch (error) {
    console.error("Error in request interceptor:", error);
    return Promise.reject(error);
  }
});

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 419) {
      // Clear the token from the api instance
      delete api.defaults.headers.common["X-XSRF-TOKEN"];
      return api(error.config);
    }
    return Promise.reject(error);
  }
);

export default api;
